export const environment = {
  production: true,
  API_BASE_URL: '/api',
  VERSION: 'v7.14.1.2.1.4'
};
